import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';

export interface UpdateColumnConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isSubmitting?: boolean;
}

export const UpdateColumnConfirmDialog: React.FC<UpdateColumnConfirmDialogProps> = React.memo(({
  open,
  onClose,
  onConfirm,
  isSubmitting = false,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2.5,
          p: 1,
        },
      }}
    >
      <DialogTitle sx={{ pb: 1, pt: 2, px: 2.5, fontWeight: 700, fontSize: '1.05rem', color: 'text.primary' }}>
        Update Column Option?
      </DialogTitle>

      <DialogContent sx={{ px: 2.5, py: 1 }}>
        <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.875rem', lineHeight: 1.5 }}>
          All leads having this option will be updated with the new option value.
        </Typography>
      </DialogContent>

      <DialogActions sx={{ px: 2.5, pb: 2, pt: 1.5, gap: 1 }}>
        <Button onClick={onClose} color="inherit" disabled={isSubmitting} sx={{ textTransform: 'none', fontWeight: 600 }}>
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          color="primary"
          variant="contained"
          disabled={isSubmitting}
          autoFocus
          sx={{ textTransform: 'none', fontWeight: 600, px: 2.5, borderRadius: '8px', boxShadow: 'none' }}
        >
          {isSubmitting ? 'Updating...' : 'Update'}
        </Button>
      </DialogActions>
    </Dialog>
  );
});

UpdateColumnConfirmDialog.displayName = 'UpdateColumnConfirmDialog';
